import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

const customRoutes = [
  { method: "GET", path: "/check", handlerName: "checkIfDeleted" },
  { method: "GET", path: "/date-range", handlerName: "getByDateRange" },
];

const baseService = createCrudService(
  "deleted-potential-shifts",
  customRoutes,
  router,
);

baseService.checkIfDeleted = (
  date,
  startTime,
  endTime,
  clientId,
  caregiverId,
) => {
  const params = new URLSearchParams({
    date,
    startTime,
    endTime,
    clientId: clientId || "",
    caregiverId: caregiverId || "",
  });
  return api.getCall(
    `/api/deleted-potential-shifts/check?${params.toString()}`,
  );
};

baseService.getByDateRange = (startDate, endDate) => {
  const params = new URLSearchParams({
    startDate,
    endDate,
  });
  return api.getCall(
    `/api/deleted-potential-shifts/date-range?${params.toString()}`,
  );
};

export const deletedPotentialShiftsService = baseService;
